// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__KOL08","name":"ConsentHeader_name__M8gJS","birthday":"ConsentHeader_birthday__3gzD1","skeleton":"ConsentHeader_skeleton__3Shf6"};